@if (coverage(); as coverage) {
<div class="card__wrapper" [ngClass]="{ selected: isSelected() && !isFinished() }">
  <button class="header__wrapper" (click)="selectCoverage()">
    <div class="flex gap-3 items-center">
     

      <span class="text-gray-600 font-semibold text-lg">{{
        coverage.title
        }}</span>

      @if (coverage.recommended) {
      <app-recommended-badge />
      }
    </div>
    @if (!isFinished()) {
    <input type="checkbox" [checked]="isSelected()"
      class="w-5 h-5 border rounded-xl cursor-pointer border-gray-300 mr-2" />
    }
  </button>

  <div class="border-b border" [ngClass]="{ selected: isSelected() && !isFinished() }"></div>

  <div class="body__wrapper">
    <div class="flex flex-col">
      <div class="flex items-baseline">
        <div>
          <app-coverage-price [coverage]="coverage" [currency]="coverage.currency"/>
         
        </div>

      </div>

      @if (getDetailEntries()) {
      <div class="flex">
        @if (viewDetail) {
        <div class="flex flex-col text-left gap-2">
          <div class="text-gray-700 text-left text-wrap">

            @for(item of getDetailEntries(); track item){

            <div class="font-medium">{{
              item.name | titlecase
              }}</div>

            }

          </div>
          <button class="flex text-primary-700 font-semibold text-sm" tabindex="0" (click)="toggleViewDetail()"
            (keydown)="toggleViewDetail()">
            Ocultar detalle
          </button>
        </div>
        } @else {
        <button class="text-primary-700 font-semibold text-sm" tabindex="0" (click)="toggleViewDetail()"
          (keydown)="toggleViewDetail()">
          Ver detalle
        </button>
        }
      </div>
      }
    </div>
  </div>
</div>
}